import { Field, ErrorMessage } from 'formik';

const City = ({ loading }) => {
  return (
    <div>
      <label htmlFor='addr_city'>City</label>

      <Field
        id='addr_city'
        aria-label='city'
        name='addr_city'
        type='text'
        disabled={loading}
      />

      <ErrorMessage
        name='addr_city'
        component='div'
      />
    </div>
  );
};

export default City;